<template>
    <teleport to="body">
        <Modal :title="title" :visible="isVisible" size="medium">
            <div v-if="!showSuccessMessage && !showFailedMessage">
                {{ description }}
            </div>
            <div v-if="!showSuccessMessage && !showFailedMessage" class="mt-2 h-80">
                <v-date-picker v-model="targetDate">
                    <template v-slot="{ inputValue, togglePopover }">
                        <input
                            style="height: 38px;"
                            :value="inputValue"
                            class="bg-white dark:bg-gray-500
                                 rounded-md
                                 text-gray-700 dark:text-gray-100
                                 w-full py-1 px-2
                                 appearance-none
                                 border border-gray-300 dark:border-gray-900
                                 focus:outline-none
                                 focus:border-sky-blue-500"
                            readonly
                            @click="togglePopover()"
                        />
                    </template>
                </v-date-picker>
            </div>
            <div v-if="showSuccessMessage" class="bg-green-200 text-black p-2">
                Schedule items have been successfully copied.
            </div>
            <div v-if="showFailedMessage" class="bg-red-200 p-2">
                There was an error copying your schedule items, please try again.
            </div>
            <template #footer-buttons>
                <Button
                    variety="warning"
                    @click="handleClose"
                >
                    Close
                </Button>
                <Button
                    v-if="!showSuccessMessage && !showFailedMessage"
                    variety="confirm"
                    @click.stop="handleSave"
                >
                    Copy
                </Button>
            </template>
        </Modal>
    </teleport>
</template>

<script>
import {defineComponent, ref, watch} from "vue";
import Modal from "../../../../components/Modal.vue";
import Button from "../../../../components/forms/Button.vue";
import {DateTime} from "luxon";

export default defineComponent({
    name: "CopyMultipleScheduleModal",
    components: {
        Button,
        Modal
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        defaultTargetDate: {
            type: Object,
            required: false,
            default: null,
        },
        showSuccessMessage: {
            type: Boolean,
            required: false,
            default: false,
        },
        showFailedMessage: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: "Copy A Week's Schedule Block"
        },
        description: {
            type: String,
            required: false,
            default: "This will copy all schedule items from the current week to the week starting on the selected date."
        },
    },
    emits: [
        'save',
        'close'
    ],
    setup(props, {emit}){
        const targetDate = ref(null);

        watch(() => props.defaultTargetDate, (newVal) => {
            if (newVal) {
                targetDate.value = newVal;
            }
        }, { immediate: true });

        const handleSave = () => {
            emit('save', targetDate.value);
        }

        const handleClose = () => {
            emit('close');
        }

        return {
            handleSave,
            handleClose,
            targetDate
        }
    }
})
</script>

<style scoped>

</style>
